import { useMutation, useQueryCache } from "react-query";
import { CheckInAPI } from "api/judge/checkIn";
import { CHECK_IN } from "helpers/constants";

export default function useUpdateEventParticipationCheckInNote() {
  const queryCache = useQueryCache();

  return useMutation(CheckInAPI.updateCheckInNote, {
    onSuccess: ({ message }) => {
      queryCache.invalidateQueries(CHECK_IN);
    },
  });
}
